var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrongIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.676 20.1451C18.2576 20.5635 17.5792 20.5635 17.1608 20.1451L0.969559 3.95387C0.551141 3.53545 0.551141 2.85706 0.96956 2.43864L2.83637 0.571834C3.25479 0.153415 3.93318 0.153416 4.3516 0.571835L20.5428 16.7631C20.9612 17.1815 20.9612 17.8599 20.5428 18.2783L18.676 20.1451ZM4.77592 19.8486C4.3575 20.267 3.67911 20.267 3.26069 19.8486L1.25297 17.8409C0.83455 17.4224 0.834551 16.744 1.25297 16.3256L16.7359 0.842672C17.1543 0.424253 17.8327 0.424254 18.2512 0.842672L20.2589 2.8504C20.6773 3.26882 20.6773 3.94721 20.2589 4.36563L4.77592 19.8486Z",
    fill: "#1D2837"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongIcon);
export default __webpack_public_path__ + "static/media/wrong_icon.3269994d.svg";
export { ForwardRef as ReactComponent };